import { Box, Flex, Text } from '@chakra-ui/react';
import { ButtonText, OutlineCard } from '@morressier/alembic';
import { IOrganizationForm } from 'src/components/UserRegistrationSteps/StepThree/signupHook';
import EditAdditionalAffiliationDetailsModal from './EditAdditionalAffiliationDetailsModal';
import { handleOpenUrl } from '../UpdateAffiliationDetails';
import RinggoldBadge from 'src/components/RinggoldBadge';

const UpdateAdditionalAffiliation = ({
  data,
  organizationId
}: {
  data: {
    additionalAffiliations: IOrganizationForm[];
    affiliationDetails: IOrganizationForm;
  };
  organizationId: string;
}) => {
  return (
    <Flex direction="column" width="100%" gap={3}>
      <Flex align={'center'} justifyContent={'space-between'}>
        <Text textStyle="headingGroup">Secondary Affiliation(s)</Text>
        <EditAdditionalAffiliationDetailsModal
          data={data}
          organizationId={organizationId}
        />
      </Flex>
      <OutlineCard width="100%">
        {data?.additionalAffiliations?.length ? (
          data?.additionalAffiliations?.map((affiliation, index) => (
            <OutlineCard
              width="100%"
              borderless
              padding={4}
              key={affiliation?.organizationName + index}
            >
              <Text textStyle="headingItem">
                {affiliation?.ringgoldId && <RinggoldBadge />}{' '}
                {affiliation.organizationName}
              </Text>
              <Flex direction={'column'}>
                <Text textStyle="textBody">
                  {affiliation?.department || ''}
                </Text>
                <Text textStyle="textBody">
                  {affiliation?.country || ''} ({affiliation?.countryCode})
                </Text>
                <Text textStyle="textBody">
                  {affiliation?.streetAddress || ''},{' '}
                  {affiliation?.stateOrRegion || ''}
                </Text>
                <Text textStyle="textBody">
                  {affiliation?.city || ''}
                  {affiliation?.postalCode
                    ? `- ${affiliation?.postalCode}`
                    : ''}
                </Text>
                <Box>
                  <ButtonText
                    onClick={() => handleOpenUrl(affiliation.url || '')}
                    whiteSpace="normal"
                    wordBreak="break-all"
                  >
                    {affiliation.url}
                  </ButtonText>
                </Box>
              </Flex>
            </OutlineCard>
          ))
        ) : (
          <OutlineCard width="100%" padding={4} borderless>
            <Text color="GrayText" textStyle="textBody">
              No data available
            </Text>
          </OutlineCard>
        )}
      </OutlineCard>
    </Flex>
  );
};

export default UpdateAdditionalAffiliation;
